<template>
  <v-navigation-drawer v-model="$store.state.drawer" v-bind="$attrs" app fixed :clipped="clipped" :mini-variant.sync="miniVariant" @input="$emit('update:drawer', $event)" :permanent="drawer_clientes">

    <template v-slot:prepend>
      <v-toolbar dark color="primary">
          <v-list>
              <v-list-item>
              <v-list-item-icon>
                  <v-icon>mdi-briefcase</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                  <v-list-item-title>Sistema Gerencial</v-list-item-title>
              </v-list-item-content>
              </v-list-item>
          </v-list>
      </v-toolbar>

      <v-list v-if="$auth.check()" class="py-0">
        <v-list-item>
          <v-list-item-content>
              <v-list-item-title class="font-weight-bold">{{ $auth.getUser().name }}</v-list-item-title>
              <v-list-item-title>Terminal: {{ terminal }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="d-flex flex-row">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="lockApp">
                  <v-icon>mdi-lock</v-icon>
                </v-btn>
              </template>
              Travar Sistema
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="logout">
                  <v-icon>mdi-logout</v-icon>
                </v-btn>
              </template>
              Sair do Sistema
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-calendar-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ dataehora }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </template>
      
    <v-divider></v-divider>

    <app-menu :mini-variant="miniVariant"></app-menu>
    <!-- <app-menu2 :mini-variant="miniVariant"></app-menu2> -->
    <!-- <app-menu3 :mini-variant="miniVariant"></app-menu3> -->

    <template v-slot:append>
      <div class="pa-1 text-center">
        <span>{{ APP_VERSION }}</span>
      </div>
    </template>

  </v-navigation-drawer>
</template>

<script>

  import AppMenu from "./AppMenu";
  // import AppMenu2 from "./AppMenu2";
  // import AppMenu3 from "./menus/AppMenu";
  import config from "@/app/config";

  export default {
    components: {
      AppMenu,
      // AppMenu2,
      // AppMenu3,
    },
    
    props: {
      drawer: {
        type: Boolean,
        default: true
      },
      permanent: {
        type: Boolean,
        default: true
      }
    },
    
    data() {
      return {
        clipped: false,
        fixed: true,
        miniVariant: false,
        dataehora: '',
        APP_VERSION: config.APP_VERSION,
        terminal: null,
      }
    },

    mounted() {
      this.updateDateAndTime();
      setInterval(() => {
        this.updateDateAndTime();
      }, 5000);

      if (this.$auth.check()) {
        this.terminal = this.$store.state.configuracoes.APP_TERMINAL;
      }
    },

    methods: {
      logout() {
        // setTimeout(() => {
          this.$auth.logout();
          this.$router.push("/login");
        // }, 1000);
      },

      updateDateAndTime() {
        let d = new Date();
        this.dataehora = d.toLocaleDateString('pt-BR') + ' '+ d.getHours() + ':' + d.getMinutes();
      },

      lockApp() {
        const user = this.$auth.getUser();
        const currentPath = this.$route.path;
        this.$auth.logout();
        this.$router.push(`/login?user=${user.email}&redirect=${currentPath}`);
      },
    },

    computed: {
      drawer_clientes() {
        return this.$store.state.financeiro.drawer_clientes; 
      },

      configuracoes() {
        return this.$store.state.configuracoes;
      },
    },
  }
</script>

<style scoped>
</style>